import { cn } from "../../lib/utils";

export const NeuCard = ({ className, children, inset = false, ...rest }) => (
  <div className={cn(inset ? "neu-in" : "neu", "p-6", className)} {...rest}>
    {children}
  </div>
);

export const NeuButton = ({ className, children, variant = "default", ...rest }) => {
  const styles = {
    default: "text-foreground hover:text-primary",
    primary: "text-primary-foreground bg-primary hover:brightness-110",
    danger: "text-destructive hover:brightness-110",
  };
  return (
    <button
      className={cn(
        "rounded-2xl bg-background px-5 py-3 text-sm font-semibold shadow-neu-sm touch-manipulation select-none",
        "transition-[box-shadow,transform,color,filter] duration-300 hover:-translate-y-0.5 hover:shadow-neu",
        "active:translate-y-0 active:shadow-neu-in focus:outline-none focus:ring-2 focus:ring-ring",
        "disabled:opacity-50 disabled:pointer-events-none",
        styles[variant],
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export const NeuInput = ({ className, ...rest }) => (
  <input
    className={cn(
      "h-12 w-full rounded-2xl bg-background px-4 text-sm leading-none shadow-neu-in",
      "text-foreground placeholder:text-muted-foreground/70 focus:outline-none focus:ring-2 focus:ring-ring",
      className
    )}
    {...rest}
  />
);

export const NeuSelect = ({ className, children, ...rest }) => (
  <select
    className={cn(
      "neu-select h-12 w-full rounded-2xl bg-background px-4 text-sm leading-none shadow-neu-in",
      "text-foreground focus:outline-none focus:ring-2 focus:ring-ring",
      className
    )}
    {...rest}
  >
    {children}
  </select>
);
